module.exports = __webpack_public_path__ + "static/media/carbs_icon.a8d37c25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carbs_icon.svg
// module id = 153
// module chunks = 0